import { RegistryOrderError, type RegistryOrderErrorKind } from '@/services/registry-order-error';

/** Plain words for the refusals a start, a download or an add to the
 * report can meet. The rest show the API's own sentence: a 404 in
 * particular says which of the order, the extraction or the Word file is
 * missing, and `markers_damaged` says how to repair the file; no fixed
 * wording would. */
const REFUSAL_WORDS: Partial<Record<RegistryOrderErrorKind, string>> = {
  digest_in_progress: "Another extraction is already reading this order's documents.",
  no_documents:
    "None of the delivered files can be read: the extraction reads the delivered PDFs, not the desk's trace reports.",
  digest_disabled: 'Extracting document information is switched off in this environment.',
  digest_not_completed: 'There is no completed extraction to add; run it first.',
  report_no_content: 'The report has no document yet: pick the submitted file first.',
  report_busy: 'The report is being edited; try again when it is back in QA.',
  content_changed: 'The report changed since this screen was read: reload and try again.',
};

/** Why a report at `stage` takes no content now: what the disabled
 * control's tooltip says before the click, and what the API's
 * `report_stage` refusal says after it. */
export function reportStageWords(stage: string | null): string {
  if (stage === 'processing_feedback') {
    return 'The report is being edited; try again when it is back in QA.';
  }
  if (stage === 'awaiting_file_selection' || stage === 'awaiting_fulfilment') {
    return 'Pick the submitted file first.';
  }
  return `The report is not at a stage that takes content (${stage ?? 'unknown'}).`;
}

/** What a failed start, read, download, preview or add says. */
export function describeDigestError(error: Error): string {
  if (!(error instanceof RegistryOrderError)) {
    return error.message;
  }
  if (error.kind === 'report_stage') {
    return reportStageWords(error.existingStatus);
  }
  return REFUSAL_WORDS[error.kind] ?? error.message;
}
